import { render, staticRenderFns } from "./InputSigarus.vue?vue&type=template&id=27353607&"
import script from "./InputSigarus.vue?vue&type=script&lang=js&"
export * from "./InputSigarus.vue?vue&type=script&lang=js&"
import style0 from "./InputSigarus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports